import { FaEdit } from '@react-icons/all-files/fa/FaEdit';
import { MdErrorOutline } from '@react-icons/all-files/md/MdErrorOutline';
import { TiTick } from '@react-icons/all-files/ti/TiTick';
import React from 'react';

import { Flex } from '../Core/Flex';
import StyledLink from '../StyledLink';
import Text from '../Text';
import { TEXT_STYLES } from '../Text/constants';

interface IFormFeedbackMessageProps {
  feedbackMessages: { success?: string; error?: string; update?: string };
  editProfileUrl: string | undefined;
  showError: boolean;
  showSuccess: boolean;
}

const FormFeedbackMessage: FCWithClassName<IFormFeedbackMessageProps> = (
  props
) => {
  const { editProfileUrl, showError, showSuccess } = props;
  if (showSuccess) {
    return (
      <Flex direction="column" align="center">
        <TiTick className="text-green-500 text-[80px] mb-4" />
        <Text variant={TEXT_STYLES.H4} className="mx-auto text-center">
          {props.feedbackMessages.success}
        </Text>
      </Flex>
    );
  } else if (editProfileUrl) {
    return (
      <Flex align="center" className="mx-auto my-0">
        <Text variant={TEXT_STYLES.H4} className="mx-auto text-center">
          {props.feedbackMessages.update}
        </Text>
        <StyledLink
          href={editProfileUrl ?? undefined}
          className="ml-4"
        >
          <FaEdit className="text-black-900 text-[50px]" />
        </StyledLink>
      </Flex>
    );
  } else if (showError) {
    return (
      <Flex direction="column" align="center">
        <MdErrorOutline className="text-orange-500 text-[80px] mb-4" />
        <Text variant={TEXT_STYLES.H4} className="mx-auto text-center">
          {props.feedbackMessages.error}
        </Text>
      </Flex>
    );
  } else {
    return null;
  }
};

export default FormFeedbackMessage;
